<template>
  <div class="page_tePaymentDtl">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con" v-if="!loading">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item>日志报销</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/logReimbursement',query:{
            activeName,tabName
          } }">{{tabName}}</el-breadcrumb-item>
          <el-breadcrumb-item>{{type=='dtl' ? '详情' : type=='add' ? '填写报销单' : type=='edit' ? '编辑' : '审批'}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName3" type="card" v-if="type=='approve'">
          <el-tab-pane label="审批内容" name="0"></el-tab-pane>
          <el-tab-pane label="工作流" name="1"></el-tab-pane>
          <el-tab-pane label="流程记录" name="2"></el-tab-pane>
        </el-tabs>
        <div v-if="activeName3=='0'">
          <!-- 报销单 -->
          <div class="reimbursementBox">
            <el-form :model="reiForm">
              <el-form-item label="报销人:" v-if="type=='add'">
                <div class="flex aic">
                  <!-- <el-cascader ref="cascaderArrDep" v-model="reiForm.depName" :props="props" clearable placeholder="选择部门" filterable :options="departmentList" style="width: 180px;margin-right:15px" size="small" :show-all-levels="false" @change="changeDep"></el-cascader> -->
                  <el-select v-model="written" placeholder="选择人员" clearable size="small" value-key="userid" style="width: 180px;margin-right:15px" filterable @change="changeUser">
                    <el-option v-for="(item,index) in customerList" :key="index" :label="item.username" :value="item"></el-option>
                  </el-select>
                  <el-date-picker type="month" placeholder="" v-model="listQuery.applyMonth" value-format="yyyy-MM" style="width:180px;margin-right:10px" size="small" :clearable="false" @change="changeApplyMonth"></el-date-picker>
                  <!-- <el-date-picker type="month" placeholder="" v-model="timeEnd" value-format="yyyy-MM" style="width:180px" size="small" :clearable="false" @change="changeApplyMonth"></el-date-picker> -->
                </div>
              </el-form-item>
              <el-form-item label="报销人:" v-else>
                <!-- <span>{{depName}}</span> -->
                <span style="margin-left:10px">{{reiForm.writtenName}}</span>
                <span style="margin-left:30px">经办人： {{reiForm.writtenName}}</span>
              </el-form-item>

            </el-form>

            <div class="verRecBox">
              <div class="Reititle"><span class="titleLine">|</span> 日志记录</div>
              <el-table :data="logData" border class="doc_table" style="width:860px;margin-top:10px" max-height="400px">
                <el-table-column prop="applyTime" label="日志日期" min-width="100" :show-overflow-tooltip="true" align="center">
                  <template slot-scope={row}>{{row.applyTime ? row.applyTime.split('T')[0] : ''}}</template>
                </el-table-column>
                <el-table-column prop="advanceNum" label="日志编号" min-width="160" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="advanceType" label="费用类别" min-width="100" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="totalFees" label="日志金额" min-width="100" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="sevrvceDeptName" label="服务部门" min-width="140" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="descFees" label="说明" min-width="200" :show-overflow-tooltip="true" align="center">
                </el-table-column>
              </el-table>

              <div v-if="logData.length>0" class="logAmount">日志金额合计:￥{{ logAmount}}</div>
            </div>
            <div class="flex aic">
              <div class="Reititle" style="margin-bottom: 10px;"><span class="titleLine">|</span> {{type=='add' || type=='edit' ? '填写报销单' : '报销单'}}</div>
              <!-- <el-button type="text" style="margin-left:30px" @click="printClick('printBox','')">打印/下载</el-button> -->
            </div>
            <div class="reiTableBox" v-show="type!='dtl'">
              <el-form :inline="true" :model="reiForm">
                <el-form-item label="报销日期:">
                  <el-date-picker type="date" placeholder="" v-model="reiForm.reimbTime" value-format="yyyy-MM-dd" style="width:150px" size="small"></el-date-picker>
                </el-form-item>
              </el-form>
              <table width="100%" border="0" cellspacing="1" cellpadding="4" class="writeOffTable" align="center">
                <tr>
                  <td colspan="6" class="reiTableBox_title">
                    <el-form :inline="true" :rules="rule" style="margin:5px 0 5px 40px" label-width="100px" v-if="writeOffData.length>0">
                      <el-form-item label="发票抬头:" prop="companyName">
                        <el-select v-model="writeOffData[0].companyName" placeholder="" size="small" style="width: 350px;" clearable filterable>
                          <el-option v-for="(item, index) in legList" :key="index" :label="item.comp" :value="item.comp"></el-option>
                        </el-select>
                      </el-form-item>
                      <!-- <el-form-item label="部门名称:">
                        <el-cascader ref="cascaderArrDep" v-model="writeOffData[0].depName" :props="props" clearable placeholder="" filterable :options="departmentList" style="width: 180px;" size="small" :show-all-levels="false"></el-cascader>
                      </el-form-item> -->
                    </el-form>
                  </td>
                </tr>
                <tr>
                  <td width="150px" class="font-center reiTableBox_title">发生日期</td>
                  <td width="150px" class="font-center reiTableBox_title">
                    <span class="required">*</span>报销内容
                  </td>
                  <td width="70px" class="font-center reiTableBox_title">单据张数</td>
                  <td width="100px" class="font-center reiTableBox_title">金额</td>
                  <td width="150px" class="font-center reiTableBox_title">备注</td>
                  <td width="260px" class="font-center reiTableBox_title">发票号码</td>
                  <td width="60px" class="font-center reiTableBox_title">操作</td>
                </tr>
                <tbody v-for="(item,index) in writeOffData" :key="index">
                  <tr v-if="index!=0">
                    <td colspan="6" class="reiTableBox_title">
                      <el-form :inline="true" label-width="100px" :rules="rule">
                        <el-form-item label="发票抬头:" prop="companyName" style="margin:5px 0 5px 40px">
                          <el-select v-model="item.companyName" placeholder="" size="small" style="width: 350px;" clearable filterable>
                            <el-option v-for="(item, index) in legList" :key="index" :label="item.comp" :value="item.comp"></el-option>
                          </el-select>
                        </el-form-item>
                        <!-- <el-form-item label="部门名称:">
                          <el-cascader ref="cascaderArrDep" v-model="item.depName" :props="props" clearable placeholder="" filterable :options="departmentList" style="width: 180px;" size="small" :show-all-levels="false"></el-cascader>
                        </el-form-item> -->
                      </el-form>
                    </td>
                  </tr>
                  <tr v-for="(row,i) in item.reiData" :key="i">
                    <td width="150px" class="font-center">
                      <el-date-picker type="date" placeholder="" v-model="row.occurDate" value-format="yyyy-MM-dd" style="width:140px" size="small"></el-date-picker>
                    </td>
                    <td width="150px" class="font-center">
                      <el-select v-model="row.reimbursementContent" placeholder="" clearable filterable style="width:140px" size="small">
                        <el-option v-for="(item,index) in teContList" :key="index" :value="item.name"></el-option>
                      </el-select>
                    </td>
                    <td width="70px" class="font-center">
                      <el-input v-model="row.documentsNum" style="width:60px" size="small"></el-input>
                    </td>
                    <td width="100px" class="font-center">
                      <el-input type="number" v-model="row.amounts" style="width:90px" size="small"></el-input>
                    </td>
                    <td width="150px" class="font-center">
                      <el-input v-model="row.remark" style="width:140px" size="small"></el-input>
                    </td>
                    <td width="260px" class="font-center">
                      <el-input v-model="row.invoiceNum" style="width:220px" size="small" @blur="judgeRepeat(row,index)"></el-input>
                      <i class="el-icon-circle-plus icon01 icon02" @click="addInvoiceNum(row,index)" title="添加多个发票号码"></i>
                    </td>
                    <td width="60px" class="font-center">
                      <div class="injuryTabBtn">
                        <el-button type="text" @click="delLine(item,index,i)">删除</el-button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="flex reiTableBot">
                <!-- <div class="flex aic cp" @click="addLine">
                  <i class="el-icon-circle-plus icon01"></i>
                  <el-button type="text" style="margin-left:5px">增加行</el-button>
                </div> -->
                <div class="flex aic cp" style="margin-left:30px" @click="addPage">
                  <i class="el-icon-circle-plus icon01"></i>
                  <el-button type="text" style="margin-left:5px">增加一页</el-button>
                </div>
                <el-button type="text" style="margin-left:30px" @click="complete">完成</el-button>
              </div>
            </div>
            <el-button type="primary" @click="printClick('printBox','')" style="margin:20px 0" v-if="tabName == '财务审核'">打印/下载</el-button>
            <div id="printBox" class="printBox">
              <div v-for="(item,index) in rei" :key="index" :class="index%2!=0 && index!=0 ? 'reiItem pb' : 'reiItem'">
                <div :id="'checked' + index" style="margin:10px 0" v-if="logData.length>0 && (tabName!='报销单' && type!='dtl')">
                  <el-checkbox v-model="item.checked">勾选打印</el-checkbox>
                </div>
                <div class="reiTop flex">
                  <div class="flex">
                    <div class="qrcode">
                      <img class="cp" :src="imgHead + reiForm.qrcodeUrl" alt="" v-if="reiForm.qrcodeUrl!=undefined && reiForm.qrcodeUrl" @click="showQRcode = true">
                      <img v-else src="./../../assets/images/qrcode.png" alt="">
                    </div>
                    <div style="padding-top: 10px;">
                      <div class="reiType">工作日志</div>
                      <div class="reiRnumber">NO:{{item.AdvanceNum}}</div>
                    </div>
                  </div>
                  <div class="centerTitle">
                    <div class="reimbursementTitle">报&nbsp;&nbsp;&nbsp;&nbsp;销&nbsp;&nbsp;&nbsp;&nbsp;单</div>
                    <hr width="130px" color="#000" style="margin-top:-1px;border-color:#000" height="1px">
                    <hr width="130px" color="#000" style="margin-top:-5px;border-color:#000">
                  </div>
                  <div class="flex sb aic reiTopRight">
                    <div class="accountBox">
                      <div class="accountName">付款：{{ item.companyName }}</div>
                      <div class="accountName">收款：{{ reiForm.writtenName }}</div>
                    </div>
                  </div>
                </div>
                <div class="reiInfo flex sb">
                  <div class="flex">
                    <div>发票抬头：</div>
                    <div class="answer">{{item.companyName}}</div>
                    <!-- <div>部门：</div>
                    <div class="answer">{{writeOffData[0].depName ? writeOffData[0].depName[writeOffData[0].depName.length - 1] : ''}}</div> -->
                  </div>
                  <div class="flex aic reiDate">
                    <div class="answer2">{{moment(reiForm.reimbTime).year()}}</div>
                    <div>年</div>
                    <div class="answer2">{{moment(reiForm.reimbTime).month() + 1}}</div>
                    <div>月</div>
                  </div>
                </div>
                <table width="99%" border="0" cellspacing="1" cellpadding="4" class="tabtop13" align="center">
                  <tr>
                    <td colspan="2" class="font-center titfont">发生日期</td>
                    <td width="35%" class="font-center titfont" rowspan="2">报销内容</td>
                    <td width="6%" class="font-center titfont" rowspan="2">单据张数</td>
                    <td colspan="9" class="font-center titfont">金额</td>
                    <td class="font-center titfont" rowspan="2">备注</td>
                  </tr>
                  <tr>
                    <td width="5%" class="font-center">月</td>
                    <td width="5%" class="font-center">日</td>
                    <td width="3%" class="font-center">百</td>
                    <td width="3%" class="font-center">十</td>
                    <td width="3%" class="font-center">万</td>
                    <td width="3%" class="font-center">千</td>
                    <td width="3%" class="font-center">百</td>
                    <td width="3%" class="font-center">十</td>
                    <td width="3%" class="font-center">元</td>
                    <td width="3%" class="font-center">角</td>
                    <td width="3%" class="font-center">分</td>
                  </tr>
                  <tr v-for="(row,index) in item.reiData" :key="index">
                    <td class="font-center">{{row.occurDate ? moment(row.occurDate).month() + 1 : ''}}</td>
                    <td class="font-center">{{row.occurDate ? moment(row.occurDate).date() : ''}}</td>
                    <td class="font-center">{{row.reimbursementContent}}</td>
                    <td class="font-center">{{row.documentsNum}}</td>
                    <td class="font-center">{{getNum(row.amounts,'bw')}}</td>
                    <td class="font-center">{{getNum(row.amounts,'sw')}}</td>
                    <td class="font-center">{{getNum(row.amounts,'w')}}</td>
                    <td class="font-center">{{getNum(row.amounts,'q')}}</td>
                    <td class="font-center">{{getNum(row.amounts,'b')}}</td>
                    <td class="font-center">{{getNum(row.amounts,'s')}}</td>
                    <td class="font-center">{{getNum(row.amounts,'g')}}</td>
                    <td class="font-center">{{getNum(row.amounts,'j')}}</td>
                    <td class="font-center">{{getNum(row.amounts,'f')}}</td>
                    <td class="font-center"></td>
                  </tr>
                  <tr>
                    <td colspan="4">合计人民币（大写） {{numberToChinese(item.sum)}}</td>
                    <td class="font-center">{{getNum(item.sum,'bw')}}</td>
                    <td class="font-center">{{getNum(item.sum,'sw')}}</td>
                    <td class="font-center">{{getNum(item.sum,'w')}}</td>
                    <td class="font-center">{{getNum(item.sum,'q')}}</td>
                    <td class="font-center">{{getNum(item.sum,'b')}}</td>
                    <td class="font-center">{{getNum(item.sum,'s')}}</td>
                    <td class="font-center">{{getNum(item.sum,'g')}}</td>
                    <td class="font-center">{{getNum(item.sum,'j')}}</td>
                    <td class="font-center">{{getNum(item.sum,'f')}}</td>
                    <td class="font-center"></td>
                  </tr>
                  <tr>
                    <td colspan="2">主管意见</td>
                    <td colspan="2" class="font-center"></td>
                    <td colspan="9">报销人签章</td>
                    <td class="font-center">{{reiForm.writtenName}}</td>
                  </tr>
                </table>
                <div class="flex reiBot">
                  <div>批准：</div>
                  <div class="reiBotInfo"></div>
                  <div>复核：</div>
                  <div class="reiBotInfo"></div>
                  <div>报销人：</div>
                  <div class="reiBotInfo">{{reiForm.writtenName}}</div>
                </div>
              </div>
            </div>
          </div>

          <el-form>
            <el-form-item label="报销金额合计:">
              ￥{{ reiForm.writtenAmount ? reiForm.writtenAmount : '0.00' }}
            </el-form-item>
            <el-form-item :label="type=='approve' ? '备注' : '申请报销备注:'">
              <el-input type="textarea" placeholder="请输入内容" v-model="reiForm.applyRemark" :autosize="{ minRows: 2}" style="width:500px" v-if="type!='dtl'">
                <span v-if="type=='dtl'">{{ reiForm.applyRemark }}</span>
              </el-input>
            </el-form-item>

            <div class="Reititle"><span class="titleLine">|</span> 收款帐号</div>
            <el-form :model="reiForm" ref="bankForm" :rules="bankRules" style="padding-left:30px" label-width="110px">
              <el-form-item>
                {{reiForm.writtenName}}
                <!-- <el-input v-model="listQuery.serviceCenterOrCompany" size="small" clearable style="width:180px"></el-input> -->
              </el-form-item>
              <el-form-item label="银行卡开户行:" prop="depositBank">
                <el-input v-model="reiForm.depositBank" size="small" clearable style="width:300px" v-if="type=='add' || type=='edit'"></el-input>
                <span v-else>{{reiForm.depositBank}}</span>
              </el-form-item>
              <el-form-item label="银行卡号:" prop="bankAccount">
                <el-input v-model="reiForm.bankAccount" size="small" clearable style="width:300px" v-if="type=='add' || type=='edit'"></el-input>
                <span v-else>{{reiForm.bankAccount}}</span>
              </el-form-item>
            </el-form>
            <div class="btnBox">
              <el-button @click="goBack">返 回</el-button>
              <el-button type="primary" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" @click="confirmSave('2')" v-if="type=='add' || type=='edit' || type=='approve'" :disabled="isSubmit">{{type=='approve' ? '保存修改' : '仅保存草稿'}}</el-button>
              <el-button type="success" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" @click="confirmSave('3')" v-if="(type=='add' || type=='edit' || type=='approve')&& tabName == '报销单'" :disabled="isSubmit">提交报销</el-button>
              <el-button type="warning" @click="printClick('printBox','')" v-if="(type=='add' || type=='edit' || type=='approve')&& tabName == '报销单' && logData.length>0">打印/下载</el-button>
              <el-button type="danger" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" @click="Approve('0')" v-if="type=='approve'" :disabled="isSubmit">退 回</el-button>
              <!-- <el-button type="success" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" @click="confirmSave('1')" v-if="type=='approve'" :disabled="isSubmit">通 过</el-button> -->
              <el-button type="success" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" @click="Approve('1')" v-if="type=='approve'" :disabled="isSubmit">通 过</el-button>
            </div>
          </el-form>

        </div>
        <div v-if="activeName3=='1' && this.WorkerList.length>0">
          <div style="margin-left:30px">
            <el-steps direction="vertical" :active="WorkerList.length - 1" finish-status="success">
              <el-step v-for="(item,index) in WorkerList" :key="index" :title="item.nodeName" :description="item.title"></el-step>
            </el-steps>
          </div>
        </div>

        <div class="timelineBox" v-if="activeName3=='2'">
          <el-timeline>
            <el-timeline-item placement="top" v-for="(item,index) in WorkerList" :key="index">
              <el-card>
                <p>时间：{{ item.createTime ? item.createTime.replace('T',' ')  :''}}</p>
                <p>记录：{{ item.title }} <span v-if="item.remark" style="margin-left: 20px;">备注： {{ item.remark }}</span> </p>
                <p>处理人：{{ item.userName }}</p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>

    </div>
    <div v-else v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"></div>
    <el-dialog title="添加发票号码" :visible.sync="showAddInvoiceNum" width="500px">
      <el-form ref="prForm" label-width="80px">
        <el-form-item label="发票号码" v-for="(item,index) in invoiceNumList" :key="index">
          <el-input v-model="item.num" style="width:220px" size="small" @blur="judgeRepeat2(item.num,index)"></el-input>
          <el-button type="text" style="margin-left:10px" @click="delInvoiceNum(index)" v-if="invoiceNumList.length>1">删除</el-button>
        </el-form-item>
        <el-button type="text" @click="addNewInvoiceNum">添加发票号码</el-button>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddInvoiceNum = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmAddInvoiceNum" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="showQRcode" width="480px">
      <img :src="imgHead + reiForm.qrcodeUrl" alt="" style="width: 300px;height: 300px;margin-left: 50px;">
      <span slot="footer" class="dialog-footer">
        <el-button @click="showQRcode = false" size="small">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import print from 'print-js';
  import * as math from 'mathjs'
  import moment from 'moment';
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          PageModel: {
            Rows: 10000,
            Page: 1,
            OrderInput: [{
              property: "applyTime",
              order: 0
            }]
          },
          applyMonth: '',
          userId: Cookies.get("userid-b"),
          applyUserNameId: '',
          roleType: localStorage.loginRoletype,
        },
        showQRcode:false,
        writeOffData: [{
          companyName: '', //公司名称
          depName: "", //部门名
          AdvanceNum: '', //编号
          reiData: [{
            occurDate: '', //发生日期
            reimbursementContent: '', //报销内容
            documentsNum: '', //单据张数
            invoiceNum: '', //发票号码
            amounts: '', //金额
            remark: '', //备注
          }]
        }],
        imgHead: this.$store.state.EMP.imgPath,
        written: {
          username: localStorage.userName,
          userid: Cookies.get("userid-b")
        },
        logAmount: '', //日志金额合计
        id: '',
        writeOffId: null, //核销id
        reiForm: {
          id: '',
          writtenName: '', //核销提交人
          WrittenId: '', //核销提交人id
          companyName: "", //公司名
          depName: "", //部门名
          reimbTime: moment().format('YYYY-MM-DD'), //报销日期
          applyRemark: "", //申请报销备注
          writtenAmount: "", //报销金额合计
          advanceIds: "", //暂支ID
          bankAccount: '', //银行卡号
          depositBank: '', //银行卡开户行
          reimbContent: [], //报销内容
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        },
        depName: '', //部门名称
        logData: [],
        fileList: [],
        rei: [{
          companyName: '', //公司名称
          depName: "", //部门名
          AdvanceNum: '', //编号
          reiData: [{
            occurDate: '', //发生日期
            reimbursementContent: '', //报销内容
            invoiceNum: '', //发票号码
            documentsNum: '', //单据张数
            amounts: '', //金额
            remark: '', //备注
          }]
        }],
        teContList: [], //报销内容列表
        baseInfo: {},
        showDropScreen: -1,
        headPath: this.$store.state.EMP.tablePath,
        roletype: localStorage.loginRoletype,
        totalcount: 0,
        loading: false,
        type: '',
        timeStart: '',
        timeEnd: '',
        isBtnLoading: false,
        isBtnLoading2: false,
        activeName3: '0',
        WorkerList: [], //工作流
        OAdata: [],
        OAinfo: {},
        customerList: [], //客服列表
        departmentList: [], //部门列表
        legList: [], //公司列表
        companyName: '',
        props: {
          label: 'strorganname',
          value: 'strorganname',
          children: 'children',
          checkStrictly: true
        },
        activeName: '',
        tabName: '',
        delData: [], //没有权限的单子 暂时存这
        isSubmit: false,
        resId: '',
        showAddInvoiceNum: false,
        invoiceNumList: [{
          num: ''
        }],
        info: {},
        rule: {
          companyName: {
            required: true,
            message: '请选择发票抬头',
            trigger: 'blur'
          },
        },
        bankRules: {
          'depositBank': {
            required: true,
            message: '请输入银行卡开户行',
            trigger: 'blur'
          },
          'bankAccount': {
            required: true,
            message: '银行卡号',
            trigger: 'blur'
          },
        }
      }
    },
    created() {
      if (this.$route.query.type != undefined && this.$route.query.type) {
        this.type = this.$route.query.type;
        this.activeName = this.$route.query.activeName;
        this.tabName = this.$route.query.tabName;
        if (this.type == 'edit' || this.type == 'dtl' || this.type == 'approve') {
          if (this.tabName == '财务审核' || this.tabName == '待打款') {
            this.companyName = this.$route.query.companyName;
            this.writeOffId = this.$route.query.advanceId;
            this.id = this.$route.query.id;
            // this.GetJbBusiaAdvLogWritFinans();
            this.writeOffId = this.$route.query.id
            this.GetWriteoffDetail();
          } else {
            this.writeOffId = this.$route.query.id;
            this.id = this.$route.query.id;
            this.GetWriteoffDetail();
          }
        }

        if (this.type == 'approve') {
          this.GetApprovalList();
        }
      }
      this.getTeContList();
      this.getMemberList();
      this.getDepartList();
      this.getlegalsubjectlist();
      if (this.type == 'add') {
        this.aaa();
      }
      let now = moment().format('YYYY-MM-DD');
      if (moment(now).date() > 15) {
        this.listQuery.applyMonth = moment().format('YYYY-MM')
      } else {
        this.listQuery.applyMonth = moment(now).subtract(1, 'months').format('YYYY-MM');
        this.reiForm.reimbTime = moment(now).subtract(1, 'months').format('YYYY-MM-DD');
      }
    },
    methods: {
      checkPermission,
      down(url, name) {
        console.log(url, name)
        var path = url;
        const aTag = document.createElement('a')
        aTag.download = name //这里写保存时的名称
        aTag.href = path
        aTag.click();
      },
      aaa() {
        setTimeout(() => {
          this.changeUser(this.written)
        }, 100);
      },
      //获取报销内容
      getTeContList() {
        let data = {
          parentId: 1
        }
        xz.AdvanceFun(data, 'GetDicList').then(res => {
          if (res.status == 'ok') {
            this.teContList = res.data
          } else {
            this.teContList = [];
          }
        })
      },
      // 获取业务部门列表
      getDepartList() {
        xz.getorganstr('', '', {
          strIsDisable: '1'
        }).then(res => {
          if (res.status == 'ok') {
            this.departmentList = res.msg.parent[0].children
          } else {
            this.departmentList = []
          }
        })
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let str = 'GetAdvanceVerifCompanyList'
        xz.AdvanceGetFun(str).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.compList;
          } else {
            this.legList = [];
          }
        })
      },
      // 获取权限内客服列表
      getMemberList() {
        xz.GetAllLowUser(Cookies.get("userid-b")).then(res => {
          if (res.status == 'ok') {
            this.customerList = res.data;
          } else {
            this.customerList = [];
          }
        })
      },
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN" ||
          o == '[{}]'
        );
      },
      //打印
      printClick(id, ignoreIds) {
        if (this.isSubmit || this.tabName != '报销单') {
          let arr = [];
          this.rei.forEach((element, index) => {
            let d = 'checked' + index;
            arr.push(d)
            if (!element.checked) {
              let dd = 'reiItem' + index;
              arr.push(dd)
            }
          });
          const style = '.page {margin:0 10mm};' //打印时去掉眉页眉尾
          setTimeout(function () {
            printJS({
              printable: id, // 标签元素id
              type: 'html',
              targetStyles: ['*'],
              style: `.page{margin:10px;height:2000px} table{border-collapse:separate} .reiItem{ margin: 100px 0!important;}`,
              ignoreElements: arr
            });
          }, 500)
        } else {
          this.$message.warning('提交后才能打印')
        }
        //各个配置项
        //printable:要打印的id。
        //type:可以是 html 、pdf、 json 等。
        //properties:是打印json时所需要的数据属性。
        //gridHeaderStyle和gridStyle都是打印json时可选的样式。
        //repeatTableHeader:在打印JSON数据时使用。设置为时false，数据表标题将仅在第一页显示。
        //scanStyles:设置为false时，库将不处理应用于正在打印的html的样式。使用css参数时很有用，此时自己设置的原来想要打印的样式就会失效，在打印预览时可以看到效果
        //targetStyles: [’*’],这样设置继承了页面要打印元素原有的css属性。
        //style:传入自定义样式的字符串，使用在要打印的html页面 也就是纸上的样子。
        //ignoreElements：传入要打印的div中的子元素id，使其不打印。非常好用
      },
      GetAdvancesDetail() {
        this.loading = true;
        xz.GetAdvancesDetail(this.listQuery).then(res => {
          try {
            if (res.status == 'ok') {
              this.baseInfo = res.data.adVerifs;
              this.OAdata = res.data.list;
              if (this.OAdata.length > 0 && this.OAdata[0].type != '工作日志') {
                this.OAinfo = this.OAdata[0]
              }
              this.loading = false;
            } else {
              this.OAdata = [];
              this.$message.error(res.msg);
              this.loading = false;
            }
          } catch (e) {
            console.log(e)
            this.$message.error('系统出错');
            this.loading = false;
          }
        })
      },
      //删除行
      delLine(item, index, i) {
        if (item.reiData.length == 1) {
          this.writeOffData.splice(index, 1);
        } else {
          item.reiData.splice(i, 1);
        }
      },
      addLine() {
        let data = {
          occurDate: '', //发生日期
          reimbursementContent: '', //报销内容
          documentsNum: '', //单据张数
          invoiceNum: '', //发票号码
          amounts: '', //金额
          remark: '', //备注
        }
        if (this.writeOffData[this.writeOffData.length - 1].reiData.length < 6) {
          this.writeOffData[this.writeOffData.length - 1].reiData.push(data);
        } else {
          let d = {
            companyName: '', //公司名称
            depName: "", //部门名
            AdvanceNum: '', //编号
            reiData: [{
              occurDate: '', //发生日期
              reimbursementContent: '', //报销内容
              invoiceNum: '', //发票号码
              documentsNum: '', //单据张数
              amounts: '', //金额
              remark: '', //备注
            }]
          }
          this.writeOffData.push(d)
        }
      },
      addPage() {
        // let data2 = {
        //   occurDate: '', //发生日期
        //   reimbursementContent: '', //报销内容
        //   documentsNum: '', //单据张数
        //   amounts: '', //金额
        //   remark: '', //备注
        // }
        // let l = this.writeOffData[this.rei.length - 1].reiData.length;
        // for (var j = 0; j < 6 - l; j = j + 1) {
        //   this.writeOffData[this.writeOffData.length - 1].reiData.push(data2)
        // }
        let d = {
          companyName: '', //公司名称
          depName: "", //部门名
          AdvanceNum: '', //编号
          reiData: [{
            occurDate: '', //发生日期
            reimbursementContent: '', //报销内容
            documentsNum: '', //单据张数
            invoiceNum: '', //发票号码
            amounts: '', //金额
            remark: '', //备注
          }]
        }
        this.writeOffData.push(d)
      },
      complete() {
        if (this.logData.length > 0 || this.type != 'add') {
          this.getTotalAmounts();
          setTimeout(() => {
            this.rei = JSON.parse(JSON.stringify(this.writeOffData));
            let data2 = {
              occurDate: '', //发生日期
              reimbursementContent: '', //报销内容
              documentsNum: '', //单据张数
              invoiceNum: '', //发票号码
              amounts: '', //金额
              remark: '', //备注
            }
            this.rei.forEach((element, index) => {
              if (this.type == 'add' && element.AdvanceNum == '') {
                xz.GetAdvOrderCode('k').then(res => {
                  if (res.status == 'ok') {
                    this.$set(element, 'AdvanceNum', res.data)
                    this.$set(this.writeOffData[index], 'AdvanceNum', res.data)
                  }
                })
              }
              let l = element.reiData.length;
              this.$set(element, 'checked', true)
              for (var j = 0; j < 6 - l; j = j + 1) {
                element.reiData.push(data2)
              }
            });
          }, 100);
        } else {
          // this.$message.warning('暂无日志记录，不能填写报销单')
        }
      },
      getNum(num, t) {
        if (num != undefined && num) {
          num = Number(num)
          let result = '';
          let c = '';
          switch (t) {
            case 'j':
              c = num.toFixed(2).split('.')[1]
              result = parseInt((c % 100) / 10)
              break;
            case 'f':
              c = num.toFixed(2).split('.')[1]
              result = parseInt(c % 10)
              break;
            case 'g':
              result = parseInt(num % 10)
              break;
            case 's':
              if (num < 10) {
                result = ''
              } else {
                result = parseInt((num % 100) / 10)
              }
              break;
            case 'b':
              if (num < 100) {
                result = ''
              } else {
                result = parseInt((num % 1000) / 100)
              }
              break;
            case 'q':
              if (num < 1000) {
                result = ''
              } else {
                result = parseInt((num % 10000) / 1000)
              }
              break;
            case 'w':
              if (num < 10000) {
                result = ''
              } else {
                result = parseInt((num % 100000) / 10000)
              }
              break;
            case 'sw':
              if (num < 100000) {
                result = ''
              } else {
                result = parseInt((num % 1000000) / 100000)
              }
              break;
            case 'bw':
              if (num < 1000000) {
                result = ''
              } else {
                result = parseInt((num % 10000000) / 1000000)
              }
              break;
          }
          // let n2 = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
          return result
        }
      },
      //获取每张报销单的总金额
      getTotalAmounts() {
        this.writeOffData.forEach((element, index) => {
          let sum = 0;
          element.reiData.forEach(e => {
            // sum = sum + Number(e.amounts)
            sum = math.format(
              math.add(
                math.bignumber(sum), math.bignumber(Number(e.amounts))
              )
            )
          });
          this.$set(element, 'sum', sum)
          if (index == this.writeOffData.length - 1) {
            setTimeout(() => {
              this.getTotalAmounts2()
            }, 200);
          }
        });
      },
      //获取总金额
      getTotalAmounts2() {
        let sum2 = 0;
        this.rei.forEach(element => {
          // sum2 = sum2 + Number(element.sum)
          sum2 = math.format(
            math.add(
              math.bignumber(Number(sum2)), math.bignumber(Number(element.sum))
            )
          )
        });
        this.reiForm.writtenAmount = sum2;
      },
      //返回
      goBack() {
        window.close()
      },
      //保存报销单
      confirmSave(type) {
        if (this.logData.length > 0) {
          this.complete();
          // if (this.logAmount != this.reiForm.writtenAmount) {
          //   this.$message({
          //     type: 'warning',
          //     message: '报销单总金额必须等于日志总金额，当前报销单总金额为 ' + this.reiForm.writtenAmount + ' 元，日志总金额为' + this.logAmount + ' 元',
          //     duration: 5000
          //   })
          // } else {
          let canSave = true;
          let require = true;
          let require2 = true;
          // let invoiceNum = this.writeOffData[0].reiData[0].invoiceNum
          this.writeOffData.forEach((element, index) => {
            element.reiData.forEach((e, i) => {
              // if (!e.invoiceNum) {
              //   require = false;
              // }
              if (!e.reimbursementContent) {
                require2 = false;
              }
              // if (e.invoiceNum == invoiceNum && index != 0) {
              //   canSave = false;
              // }
              if (index == this.writeOffData.length - 1 && i == element.reiData.length - 1) {
                // if (require && canSave) {
                //   this.confirmSave2(type)
                // } else if (!require) {
                //   this.$message.error('发票号码是必填项！请填写发票号码')
                // } else if (!require2) {
                //   this.$message.error('报销内容是必填项！请选择报销内容')
                // } else if (require && !canSave) {
                //   this.$message.error('填写的发票号码出现重复，请检查')
                // }
                if (!require2) {
                  this.$message.error('报销内容是必填项！请选择报销内容')
                } else {
                  setTimeout(() => {
                    this.confirmSave2(type)
                  }, 200);
                }
              }
            });
          });
          // }
        } else {
          this.$message.warning('没有日志记录，不能保存')
        }
      },
      confirmSave2(type) {
        this.$refs["bankForm"].validate((valid) => {
          if (valid) {
            let arr = [];
            this.logData.forEach((element, index) => {
              arr.push(element.id)
              if (index == this.logData.length - 1) {
                this.reiForm.advanceIds = arr.toString();
                this.isBtnLoading = true;
                // if (this.reiForm.depName) {
                //   this.reiForm.depName = this.reiForm.depName.toString();
                // }
                // if (this.delData.length > 0) {
                //   this.writeOffData.concat(this.delData)
                // }
                this.complete();
                if (this.companyName && this, this.tabName == '财务审核') {
                  this.$set(this.reiForm, 'ReimbCompanyName', this.companyName)
                }
                this.reiForm.reimbContent = this.writeOffData;
                xz.AdvanceFun(this.reiForm, 'addUpdataLogVerif').then(res => {
                  if (res.status == 'ok') {
                    if (type == '2') {
                      this.$message.success('保存成功')
                      this.isSubmit = true;
                      setTimeout(() => {
                        this.goBack();
                      }, 1000);
                    } else if (type == '3') {
                      this.resId = res.data;
                      this.confirmSubmit();
                    } else {
                      this.Approve(type)
                    }
                    this.isBtnLoading = false;
                  } else {
                    this.$message.error(res.msg);
                    this.isBtnLoading = false;
                  }
                })
              }
            });
          }
        })
      },
      confirmSubmit() {
        let data = {
          id: this.resId,
          type: '2', //1.为暂支，2为日志
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        }
        xz.SubmitWriteoff(data).then(res => {
          if (res.status == 'ok') {
            this.isBtnLoading = false;
            this.$message.success('提交报销成功');
            this.isSubmit = true;
            setTimeout(() => {
              this.goBack();
            }, 1000);
          } else {
            this.$message.error(res.msg);
            this.isBtnLoading = false;
          }
        })
      },
      //审批
      // handelApprove(results) {
      //   this.confirmSave('');
      //   this.isBtnLoading = true;
      //   setTimeout(() => {
      //     this.Approve(results)
      //   }, 200);
      // },
      Approve(results) {
        this.isBtnLoading = true;
        let data = {
          type: this.tabName == '部门审核' ? '3' : '4',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
          results,
          remark: this.reiForm.applyRemark,
          busiId: this.id
        }
        xz.VerifiDepartAudit(data).then(res => {
          if (res.status == 'ok') {
            this.$message.success('操作成功！');
            this.isBtnLoading = false;
            this.isSubmit = true;
            setTimeout(() => {
              this.goBack();
            }, 1000);
          } else {
            this.$message.error(res.msg)
            this.isBtnLoading = false;
          }
        })
      },
      //获取审批流
      GetApprovalList() {
        let data = {
          type: this.tabName == '部门审核' ? '1' : '2',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
          busiId: this.writeOffId
        }
        xz.GetApprovalList(data).then(res => {
          if (res.status == 'ok') {
            this.WorkerList = res.data;
            if (this.WorkerList.length > 0) {
              let last = this.WorkerList[this.WorkerList.length - 1]
              this.WorkerList[this.WorkerList.length - 1].title = last.userName
            }
          } else {
            this.WorkerList = [];
            this.$message.error(res.msg)
          }
        })
      },
      //数字转中文大写
      numberToChinese(money) {
        // 汉字的数字
        let cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
        // 基本单位
        let cnIntRadice = ['', '拾', '佰', '仟']
        // 对应整数部分扩展单位
        let cnIntUnits = ['', '万', '亿', '兆']
        // 对应小数部分单位
        let cnDecUnits = ['角', '分', '厘', '毫']
        // 整数金额时后面跟的字符
        let cnInteger = '整'
        // 整型完以后的单位
        let cnIntLast = '元'
        // 最大处理的数字
        let maxNum = 999999999999999.9999
        // 金额整数部分
        let integerNum
        // 金额小数部分
        let decimalNum
        // 输出的中文金额字符串
        let chineseStr = ''
        // 分离金额后用的数组，预定义
        let parts
        if (money === '') {
          return ''
        }
        money = parseFloat(money)
        if (money >= maxNum) {
          // 超出最大处理数字
          return ''
        }
        if (money === 0) {
          chineseStr = cnNums[0] + cnIntLast + cnInteger
          return chineseStr
        }
        // 转换为字符串
        money = money.toString()
        if (money.indexOf('.') === -1) {
          integerNum = money
          decimalNum = ''
        } else {
          parts = money.split('.')
          integerNum = parts[0]
          decimalNum = parts[1].substr(0, 4)
        }
        // 获取整型部分转换
        if (parseInt(integerNum, 10) > 0) {
          let zeroCount = 0
          let IntLen = integerNum.length
          for (let i = 0; i < IntLen; i++) {
            let n = integerNum.substr(i, 1)
            let p = IntLen - i - 1
            let q = p / 4
            let m = p % 4
            if (n === '0') {
              zeroCount++
            } else {
              if (zeroCount > 0) {
                chineseStr += cnNums[0]
              }
              // 归零
              zeroCount = 0
              chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
            }
            if (m === 0 && zeroCount < 4) {
              chineseStr += cnIntUnits[q]
            }
          }
          chineseStr += cnIntLast
        }
        // 小数部分
        if (decimalNum !== '') {
          let decLen = decimalNum.length
          for (let i = 0; i < decLen; i++) {
            const n = decimalNum.substr(i, 1)
            if (n !== '0') {
              chineseStr += cnNums[Number(n)] + cnDecUnits[i]
            }
          }
        }
        if (chineseStr === '') {
          chineseStr += cnNums[0] + cnIntLast + cnInteger
        } else if (decimalNum === '') {
          chineseStr += cnInteger
        }
        return chineseStr
      },
      GetLogMonthsAdvanceList() {
        this.logData = [];
        xz.AdvanceFun(this.listQuery, 'GetLogMonthsAdvanceList').then(res => {
          if (res.status == 'ok') {
            this.logAmount = 0;
            this.logData = res.data.data;
            if (res.data.data.length > 0) {
              this.logData.forEach(element => {
                // this.logAmount = this.logAmount + Number(element.totalFees);
                this.logAmount = math.format(
                  math.add(
                    math.bignumber(Number(this.logAmount)), math.bignumber(Number(element.totalFees))
                  )
                )
              });
            }
          } else {
            this.logData = [];
          }
        })
      },
      changeUser(val) {
        console.log(val)
        this.listQuery.applyUserNameId = val.userid;
        // this.listQuery.applyUserName = val.username;
        this.reiForm.writtenName = val.username;
        this.reiForm.WrittenId = val.userid;
        if (this.type == 'add') {
          this.GetAdvPaymenCard();
        }
        if (this.listQuery.applyUserNameId && this.listQuery.applyMonth) {
          this.GetLogMonthsAdvanceList();
        }
      },
      changeApplyMonth() {
        if (this.listQuery.applyUserNameId && this.listQuery.applyMonth) {
          this.GetLogMonthsAdvanceList();
        }
      },
      getLogData() {
        let data = {
          ids: this.reiForm.advanceIds,
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        }
        this.logData = [];
        xz.AdvanceFun(data, 'GetAdvancesListById').then(res => {
          if (res.status == 'ok') {
            this.logAmount = 0;
            this.logData = res.data;
            if (res.data.length > 0) {
              this.logData.forEach(element => {
                // this.logAmount = this.logAmount + Number(element.totalFees);
                this.logAmount = math.format(
                  math.add(
                    math.bignumber(Number(this.logAmount)), math.bignumber(Number(element.totalFees))
                  )
                )
              });
            }
          } else {
            this.logData = [];
          }
        })
      },
      //获取报销人银行卡信息
      GetAdvPaymenCard() {
        xz.GetAdvPaymenCard(this.listQuery.applyUserNameId).then(res => {
          if (res.status == 'ok' && res.data) {
            this.reiForm.depositBank = res.data.depositBank;
            this.reiForm.bankAccount = res.data.bankAccount;
          } else {
            this.reiForm.depositBank = '';
            this.reiForm.bankAccount = '';
          }
        })
      },
      changeDep(val) {
        // console.log(val.toString())
        this.depName = val[val.length - 1]
      },
      //获取暂支报销详情
      GetWriteoffDetail() {
        this.loading = true;
        let data = {
          busiId: this.writeOffId,
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        }
        xz.GetWriteoffDetail(data).then(res => {
          if (res.status == 'ok') {
            this.reiForm = res.data;
            this.$set(this.reiForm, 'userId', Cookies.get("userid-b"));
            this.$set(this.reiForm, 'roleType', localStorage.loginRoletype);
            this.writeOffData = eval(res.data.reimbContent);
            // if (res.data.depName) {
            //   this.reiForm.depName = res.data.depName.split(',');
            //   this.depName = this.reiForm.depName[this.reiForm.depName.length - 1];
            // }
            this.getLogData();
            this.complete();
            this.loading = false;
            // this.fileList = res.data.materAcces;
          } else {
            this.$message.error(res.msg);
            this.loading = false;
          }
        })
      },
      //advid获取busid
      GetJbBusiaAdvLogWritFinans() {
        xz.GetJbBusiaAdvLogWritFinans(this.id).then(res => {
          if (res.status == 'ok') {
            this.writeOffId = res.data.advanceId;
            this.GetWriteoffDetail();
          }
        })
      },
      //判断是否重复
      judgeRepeat(row, index) {
        if (row.invoiceNum) {
          xz.GetCheckinvoiceNum(this.writeOffId, row.invoiceNum).then(res => {
            if (res.status == 'ok') {} else {
              this.$set(row, 'invoiceNum', '');
              this.$message({
                type: 'error',
                message: res.msg,
                duration: 5000
              })
            }
          })
        }
      },
      //判断是否重复
      judgeRepeat2(num, index) {
        if (num) {
          xz.GetCheckinvoiceNum(this.writeOffId, num).then(res => {
            if (res.status == 'ok') {} else {
              this.$set(this.invoiceNumList[index], 'num', '');
              this.$message({
                type: 'error',
                message: res.msg,
                duration: 5000
              })
            }
          })
        }
      },
      //添加多个发票号码
      addInvoiceNum(row, index) {
        this.info = row;
        if (row.invoiceNum) {
          let arr = row.invoiceNum.split(',');
          this.invoiceNumList = [];
          arr.forEach(element => {
            let data = {
              num: element
            }
            this.invoiceNumList.push(data)
          });
        } else {
          this.invoiceNumList = [{
            num: ''
          }]
        }
        this.showAddInvoiceNum = true;
      },
      //添加一行发票号码
      addNewInvoiceNum() {
        let data = {
          num: ''
        }
        this.invoiceNumList.push(data)
      },
      delInvoiceNum(index) {
        this.invoiceNumList.splice(index, 1)
      },
      confirmAddInvoiceNum() {
        let arr = [];
        this.invoiceNumList.forEach(element => {
          if (element.num) {
            arr.push(element.num)
          }
        });
        this.$set(this.info, 'invoiceNum', arr.toString());
        this.showAddInvoiceNum = false;
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 20px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }


  .infoBox {
    // width: 1050px;
    background: #E8F7F7;
    padding: 10px 20px;

  }

  .infoTitle {
    font-size: 14px;
    font-weight: 600;
    // text-wrap: nowrap;
    line-height: 32px;
    margin-right: 10px;
  }

  .basicInfo {
    flex-wrap: wrap;
    // width: 900px;
  }

  .infoItem {
    color: #000;
    font-size: 13px;
    min-width: 140px;
    line-height: 32px;
    margin-right: 30px;
  }

  .incInfo {
    margin-top: 10px;
  }

  .readInfo {
    padding: 0 30px;
    display: flex;
    flex-wrap: wrap;
  }

  .readInfoItem {
    width: 240px;
    margin-bottom: 15px;
    font-size: 14px;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .down {
    color: #409EFF;
    margin-right: 15px;
  }

  .cotName {
    margin: 0 10px;
    max-width: 5em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #409EFF;
  }

  .verRecBox {
    margin: 20px 0;
  }

  .Reititle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .reimbursementBox {
    /* color: red; */
    // width: 800px;
    color: #000;
  }

  .reiTableBox {
    margin: 10px 0 20px;
  }

  .reiBcg {
    background: #FEF8E4;
  }

  .reiTableTitle {
    font-size: 14px;
    justify-content: space-around;
  }

  .reiTableBot {
    width: 800px;
    justify-content: center;
    font-size: 14px;
  }

  .reiTop {
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
  }

  .reiRnumber {
    font-size: 16px;
    padding-left: 10px;
    font-weight: bold;
  }

  .reiType {
    font-size: 16px;
    padding-left: 10px;
    font-weight: bold;
  }

  .reimbursementTitle {
    text-align: center;
    font-weight: bold;
    margin-bottom: 3px;
    font-size: 24px;
  }

  .icon01 {
    color: #19bd92;
    font-size: 20px;
    cursor: pointer;
  }

  .centerTitle {
    // width: 300px;
    margin-bottom: 5px;
    font-size: 20px;
  }

  .centerTitle hr {
    margin: 10px auto 0;
  }

  .reiTopRight {
    // width: 300px;
  }

  .accountBox {
    font-size: 14px;
  }

  .qrcode {
    // margin-left: 80px;
    width: 70px;
    height: 70px;
  }

  .qrcode img {
    width: 70px;
    height: 70px;
  }

  .reiInfo {
    font-size: 14px;
    white-space: nowrap;
  }

  .answer {
    border-bottom: 1px solid #000;
    padding: 0 15px 3px;
    margin: 0 10px;
    min-width: 100px;
  }

  .answer2 {
    border-bottom: 1px solid #000;
    padding: 0 5px;
    margin: 0 3px;
  }

  .reiDate {
    padding-right: 55px;
  }

  .reiBot {
    font-size: 14px;
    margin-top: 5px;
    font-weight: bold;
    white-space: nowrap;
  }

  .reiBotInfo {
    width: 80px;
  }

  .tabtop13 {
    margin-top: 5px;
  }

  .tabtop13 td {
    background-color: #ffffff;
    height: 30px;
    line-height: 150%;
  }

  .tabtop15 td {
    padding: 8px;
    word-break: break-word;
    font-size: 14px;
  }

  .font-center {
    text-align: center
  }

  .biaoti {
    font-family: 微软雅黑;
    font-size: 26px;
    font-weight: bold;
    border-bottom: 1px dashed #CCCCCC;
  }

  .titfont {
    font-family: 微软雅黑;
    font-size: 16px;
    font-weight: bold;
    // background: url(../images/ico3.gif) no-repeat 15px center;
  }

  .bttit {
    background: #F6F6F6 !important;
  }

  .tabtxt2 {
    font-family: 微软雅黑;
    font-size: 14px;
    font-weight: bold;
    text-align: right;
    padding-right: 10px;
  }

  .tabtxt3 {
    font-family: 微软雅黑;
    font-size: 14px;
    padding-left: 15px;
    color: #000;
    margin-top: 10px;
    margin-bottom: 10px;
    line-height: 20px;
  }

  .printBox {
    width: 800px;
    // padding-top: 100px;
  }

  .printBox table {
    border: #000 2px solid;
    border-collapse: collapse;
  }

  table td,
  table th {
    border: #000 1px solid;
  }

  .btnBox {
    margin-top: 20px;
    padding: 20px 0 30px 0;
    width: 600px;
    display: flex;
    justify-content: center;
  }

  .accountName {
    min-width: 100px;
  }

  .logAmount {
    margin-top: 15px;
    font-size: 16px;
    padding-left: 15px;
  }

  // .reiItem {
  //   margin: 100px 0;
  // }

  .mt {
    margin-top: 300px;
  }

  .pb {
    page-break-after: always;
  }

  .writeOffTable {
    margin-top: 10px;
    width: 900px;
    background-color: #fff;
    padding: 8px 0;
    line-height: 40px;
  }

  .reiTableBox table td,
  .reiTableBox table th {
    border: #d2d2d2 1px solid !important;
  }

  .reiTableBox table {
    border: #d2d2d2 1px solid !important;
  }

  .reiTableBox_title {
    background: #f6f6f6;
  }

  .required {
    color: red;
    margin-right: 3px;
  }
</style>
<style>
  .page_tePaymentDtl .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_tePaymentDtl .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_tePaymentDtl .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_tePaymentDtl .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_tePaymentDtl .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_tePaymentDtl .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_tePaymentDtl .demandForm .el-form-item__label {
    color: #999;
  }

  .page_tePaymentDtl .demandForm .el-form--inline .el-form-item {
    width: 270px;
    margin-right: 0;
  }

  .page_tePaymentDtl .demandForm .el-form-item {
    margin-bottom: 0;
  }

  .page_tePaymentDtl .el-form-item {
    margin-bottom: 10px;
  }

  .reiTableBox .el-form-item {
    margin-bottom: 0;
  }

  .page_tePaymentDtl .el-form-item__error {
    top: 89%;
  }
</style>